
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 
 import {ObcNotificationMessageItem as ObcNotificationMessageItemElement} from '@oicl/openbridge-webcomponents/dist/components/notification-message-item/notification-message-item.js';
 
 
 

 
 export const ObcNotificationMessageItem = createComponent({
   react: React,
   tagName: 'obc-notification-message-item',
   elementClass: ObcNotificationMessageItemElement,
   events: {
     
     onMessageClick: 'message-click' as EventName<CustomEvent<void>>,
     onActionClick: 'action-click' as EventName<CustomEvent<void>>,
   }
  });
 
 